import { Subject } from 'rxjs';
import { HdWizard } from './hd-wizard';
import { HdWizardTimeTravelData } from './interface';
import { HdWizardStepTracker } from './step-tracker';


export class HdWizardController {
  private _wizardInstance: HdWizard;
  private _complete = new Subject<void>();
  private _requestBack = new Subject<string>();

  isCompleted: boolean;

  complete = this._complete.asObservable();
  requestBack = this._requestBack.asObservable();

  get currentStep$() {
    return this._wizardInstance.currentStep$;
  }

  get wizardState$() {
    return this._wizardInstance.wizardState$;
  }

  markAsComplete() {
    this.isCompleted = true;
    this._complete.next();
    this._complete.complete();
  }

  saveWizardStepData() {
    return this._wizardInstance.saveStepBeforeUnload();
  }

  setWizardInstance(instance: HdWizard) {
    this._wizardInstance = instance;
  }

  constructor(
    private _stepTracker: HdWizardStepTracker
  ) {
  }

  getStepTracker() {
    return this._stepTracker;
  }

  selectStep(path: string) {
    this._wizardInstance.goTo(path);
  }

  fastTravel(data: HdWizardTimeTravelData) {
    this._wizardInstance.fastTravel(data);
  }

  goBack(path?: string) {
    this._requestBack.next(path);
  }

  closeWizard() {
    this._wizardInstance.closeWizard();
  }
}
